import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import asyncComponent from './utils/asyncComponent.jsx';
import { ToastContainer, toast } from 'react-toastify';
import { initializeFirebase } from './push-notification';
import firebase from 'firebase';
import * as serviceWorker from "./serviceWorker";
import "react-toastify/dist/ReactToastify.css";
import axios from "./services"

import 'fonts/fontawesome/js/all.min.js';
import 'fonts/fontawesome/js/brands.min.js';
import 'fonts/fontawesome/js/fontawesome.min.js';
import 'fonts/fontawesome/js/regular.min.js';
import 'fonts/fontawesome/js/solid.min.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/jquery.mCustomScrollbar.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './css/flipclock.min.css';
import './css/svg-icons-animate.css';
import './css/style.css';
import './css/my-style.css';
import './css/devstyle.css';
import './css/responsive.css';

import "./fonts/fontawesome/css/all.min.css";
import './fonts/fontawesome/css/brands.min.css';
import './fonts/fontawesome/css/fontawesome.min.css';
import './fonts/fontawesome/css/regular.min.css';
import './fonts/fontawesome/css/solid.min.css';
import './fonts/fontawesome/css/svg-with-js.min.css';
import './fonts/fontawesome/css/v4-shims.min.css';

import Layout from './Layout/Layout.jsx';
import 'bootstrap/dist/js/bootstrap';
import './js/sticky-kit.js';


const initFirebase = async () => {
    firebase.initializeApp({
        apiKey: 'AIzaSyAbpSMFOrVCCGnp8NAtuoKpYX-RHJE_dLk',
        appId: '1:665924325448:web:5e7f7614682d555752487d',
        projectId: 'contestee-dev',
        messagingSenderId: "665924325448"
    });
    const messaging = firebase.messaging();
    if (firebase.messaging.isSupported()) {
        messaging.onMessage(function (payload) {
            var notification = (new Notification(
                payload.data.title,
                payload.data.message
            ).onclick = function (event) {
                event.preventDefault();
                window.location = payload.notification.click_action;
            });
        });

        await Notification.requestPermission();
        await messaging.usePublicVapidKey('BFObCYHqKdnTAoEd2eqia9C2pSts6BFbGl4p_tT3d5Srsc_laoWOOn8qHe7xeHsI9aojlJ4d_oRXbEB3JSWmlzE');
        const token = await messaging.getToken();
        if (localStorage.getItem("gtoken") != token) {
            try {
                const authorizationToken = localStorage.getItem("token");
                if (authorizationToken != null) {
                    const response = await axios.put("http://dev.contestee.net/api/v1/users",
                        { fcmToken: token },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization:": authorizationToken
                            }
                        }
                    );
                }
            } catch (error) { }
        }
        localStorage.setItem("gtoken", token);
    } else {
        localStorage.setItem("gtoken", false);
    }
};


const App = () => (
    <BrowserRouter>
        <Fragment>
            <Provider store={store}>
                <ToastContainer autoClose={2000} position={toast.POSITION.TOP_RIGHT} hideProgressBar={true} closeButton={false} />
                <Router />
            </Provider>
        </Fragment>
    </BrowserRouter>
);

const Router = () => {
    if (!firebase.apps.length) {
        initFirebase();
    }
    document.cookie = "googtrans= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
    return (
        <Switch>
            <Route path="/login" exact component={asyncComponent(() => import('./modules/Login/Login.jsx'))} />
            <Route path="/verified" exact component={asyncComponent(() => import('./modules/Email/Verified/Verified.jsx'))} />
            <Route path="/not-verified" exact component={asyncComponent(() => import('./modules/Email/NotVerified/NotVerified.jsx'))} />
            <Route path="/unenroll-cancel/:status" exact component={asyncComponent(() => import('./modules/Email/UnenrolledCancel/UnenrolledCancel.jsx'))} />
            <Route path="/logout" exact component={asyncComponent(() => import('./modules/Logout/Logout.jsx'))} />
            <Route path="/404" exact component={asyncComponent(() => import('./components/errorPage/errorPage.js'))} />
            <Route path="/signup" exact component={asyncComponent(() => import('./modules/Signup/Signup.jsx'))} />
            <Route path="/forgot-password" exact component={asyncComponent(() => import('./modules/ForgotPassword/ForgotPassword.jsx'))} />
            <Route path="/create-new-password" exact component={asyncComponent(() => import('./modules/CreateNewPassword/CreateNewPassword.jsx'))} />
            <Route path="/password-changed-successfully" exact component={asyncComponent(() => import('./modules/CreateNewPassword/PasswordChangedSuccessfully.jsx'))} />
            <Route path="/phone-verification" component={asyncComponent(() => import('./modules/PhoneVerification/phoneVerification.jsx'))} />
            <Route path="/signup-profile" component={asyncComponent(() => import('./modules/User/Profile/SignUpProfile.jsx'))} />
            <Route path="/show-tickets" component={asyncComponent(() => import('./modules/User/Tickets/votingTickets.jsx'))} />
            <Route path="/404" exact component={asyncComponent(() => import('./components/errorPage/errorPage.js'))} />
            <Route path="/" component={asyncComponent(() => import('./modules/User/index.jsx'))} />
            {/* <Redirect to="/404" /> */}
        </Switch>
    );
}

ReactDOM.render(
    <App />,
    document.getElementById('root')
);
serviceWorker.register();
export default App;
